'use strict'

// One AI-agent card for the home "agents" row: a ◆ glyph in a neutral tile +
// name (+ optional role chip) + a short caption. Clicking routes to the full
// /team-and-agents roster.
//
// Flat treatment — no card border and no accent colours (per the home
// sections' borderless look). The per-agent `color` in HOME_AGENTS is left in
// place but unused here so accents can be re-enabled later.
//
// Per-card state (fed by main.js's HOME_AGENTS via childrenAs: 'state'):
//   { name, caption, role?, placeholder? }
export const AgentCard = {
  tag: 'button',
  type: 'button',
  flow: 'y',
  gap: 'A',
  round: 'radiusControl',
  padding: 'B',
  textAlign: 'left',
  cursor: 'pointer',
  color: 'title',
  background: 'transparent',
  transition: '160ms defaultBezier background',
  ':hover': { background: 'hover' },

  onClick: (e, el) => el.router('/team-and-agents', el.getRoot()),

  AgentGlyph: {
    width: 'C',
    height: 'C',
    minWidth: 'C',
    round: 'radiusControl',
    align: 'center center',
    fontSize: 'B',
    fontWeight: '700',
    background: 'overlay',
    color: 'title',
    text: (el, s) => (s.placeholder ? '+' : '◆')
  },

  Head: {
    flow: 'x',
    gap: 'V',
    align: 'center',
    flexWrap: 'wrap',

    Name: {
      tag: 'span',
      fontSize: 'A',
      fontWeight: '700',
      color: 'title',
      text: (el, s) => s.name
    },

    // Role chip (e.g. Temo → "PM"). Hidden when the agent has no role.
    Role: {
      hide: (el, s) => !s.role,
      tag: 'span',
      fontSize: 'Y2',
      fontWeight: '700',
      padding: 'V Z',
      round: 'X',
      color: 'caption',
      background: 'overlay',
      text: (el, s) => s.role
    }
  },

  Caption: {
    tag: 'p',
    margin: '0',
    fontSize: 'Y',
    lineHeight: '1.4',
    color: 'caption',
    text: (el, s) => s.caption
  }
}
